import api from "@/lib/api";

// CREATE FOLDER
export const createFolder = async (folder_name) => {
  const res = await api.post("/media-library/folders/create", { folder_name });
  return res.data;
};

// GET FOLDER LIST
export const getFolderList = async () => {
  const res = await api.get("/media-library/getFolderList");
  return res.data; // { success, data: [{ name }] }
};

// GET ALL MEDIA IN A FOLDER
export const getAllMedia = async (folder_name) => {
  const res = await api.post("/media-library/folder", { folder_name });
  return res.data; // { success, data: [...] }
};

// GET SINGLE FILE
export const getMediaFile = async (folder_name, file_name) => {
  const res = await api.post("/media-library/file", { folder_name, file_name });
  return res.data;
};

// UPLOAD FILE
export const uploadMedia = async ({ file, folder_name, alt_text = "", description = "" }) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("folder_name", folder_name);
  formData.append("alt_text", alt_text);
  formData.append("description", description);

  const res = await api.post("/media-library/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

// DELETE MEDIA
export const deleteMedia = async (media_id) => {
  const res = await api.post(`/media-library/delete/${media_id}`);
  return res.data;
};